import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
    containerVariants,
    itemVariants,
    photoVariants,
} from "../../variants/variants";



const Section7 = () => {
    const { t } = useTranslation();
    
    return (
        <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className="min-h-[60vh]  w-full  relative ">
            <motion.img
                initial="initial"
                whileInView="whileInView"
                exit="exit"
                variants={photoVariants}
                src="/images/sustainability/green.jpg"
                className="object-cover h-full w-full object-center absolute top-0 left-0"
            />

            <motion.div             initial="initial"
            whileInView="whileInView"
            exit="exit"
            variants={photoVariants} className="h-full w-full bg-[#07B450] mix-blend-multiply absolute top-0 left-0"></motion.div>

            <div className="grid grid-cols-10   w-full relative z-50 py-28  ">
                <div className=" col-start-2 md:col-start-2 col-span-8 md:col-span-4 w-full  ">
                    <motion.h5 variants={itemVariants} className=" text-65 text-white mb-5 ">
                        {t("sustainability.carbon.title")}
                        <span className="font-light">&nbsp; {t("sustainability.carbon.subtitle")}</span>
                    </motion.h5>

                    <motion.p variants={itemVariants} className="text-white text-20 font-medium mb-10">
                        {t("sustainability.carbon.description")}
                    </motion.p>
                </div>
            </div>
        </motion.div>
    )
}

export default Section7
